import { db, app } from '../lib/firebase';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { collection, doc, getDoc, setDoc, updateDoc, query, where, getDocs } from 'firebase/firestore';
import { User } from '../types/user';
import { Organization } from '../types/organization';

export const userService = {
  /**
   * Felhasználói adatlap betöltése. Ha még nincs, a szerver (acceptUserInvite) hozza létre –
   * csak meghívóval (vagy új telepítésnél az első felhasználónak). Meghívó nélkül 'no-account' hibát dob.
   */
  async createUserIfNotExists(user: any) {
    const userRef = doc(db, 'users', user.uid);
    let userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
      try {
        const fns = getFunctions(app, 'europe-west1');
        await httpsCallable(fns, 'acceptUserInvite')({});
      } catch (e: any) {
        const err: any = new Error(e?.message || 'Ehhez a fiókhoz nincs hozzáférés.');
        err.code = e?.code === 'functions/permission-denied' ? 'no-account' : (e?.code || 'invite-failed');
        throw err;
      }
      userSnap = await getDoc(userRef);
      if (!userSnap.exists()) {
        const err: any = new Error('Ehhez a fiókhoz nincs hozzáférés.');
        err.code = 'no-account';
        throw err;
      }
    }

    const userData = userSnap.data() as User;
    // Ensure the id field is always present
    return {
      ...userData,
      id: user.uid
    };
  },

  async getUser(userId: string): Promise<User | null> {
    try {
      const userRef = doc(db, 'users', userId);
      const userSnap = await getDoc(userRef);
      
      if (userSnap.exists()) {
        return userSnap.data() as User;
      }
      return null;
    } catch (error) {
      console.error('Error getting user:', error);
      return null;
    }
  },

  async updateUser(userId: string, data: Partial<User>): Promise<void> {
    try {
      const userRef = doc(db, 'users', userId);
      await updateDoc(userRef, {
        ...data,
        updatedAt: new Date()
      });
    } catch (error) {
      console.error('Error updating user:', error);
      throw error;
    }
  }
}; 